var messages = {
  placeholder: 'Please input',
  passwordPlaceholder: 'Please input password'
};
export default messages;